import "stylesheets/booker/inline";

import { InlineBookerController } from "../../booker/inline-trigger-controller";

window.addEventListener("DOMContentLoaded", () => {
    const htmlElement = document.getElementById("root-document-tag");
    htmlElement.classList.add("inline-booker");
    htmlElement.classList.add("closed");
    const target = document.querySelector(".booker-widget-trigger");
    const ctrl = new InlineBookerController(target, htmlElement);
    ctrl.initialize();
    ctrl.connect();
    
});


